import {MasterLayout} from 'layout';
import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemDonViNgoai} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from 'constants/message';
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {Input} from 'components/tt-forms/common';

class DonViNgoai extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      ten: '',
      donViNgoaiHeThongId: '',
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      tuKhoa:'',
      search: false
    };
  }

  componentDidMount() {
    this.getListData();
  }

  handleSearch() {
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({
      tableLoading: true
    });
    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if(this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa.trim();
    }
    Danhmuc.actions.getDonViNgoai.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.donViNgoaiHeThongs,
          pageData: res.data.page,
          tableLoading: false,
          searchLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false,
          searchLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  createCategory() {
    if (this.checkValidate()) {
      let params = {
        ten: this.state.ten.trim()
      };

      this.setState({buttonLoading: true});
      if (this.state.donViNgoaiHeThongId) {
        this.props.danhMuc.updateDonViNgoai({id: this.state.donViNgoaiHeThongId},params).then(res => {
          this.getListData();
          this.toggleDialog();
          Toastr(msg.updateCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      } else {
        this.props.danhMuc.postDonViNgoai('',params).then(res => {
          this.getListData();
          this.toggleDialog();
           Toastr(msg.addCategorySucess,'success');
          this.setState({buttonLoading: false});
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
        });
      }
      this.props.validators['danhMuc'] = [];
    }
  }

  componentWillUnmount() {
    this.props.validators['danhMuc'] = [];
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleDelete(categoryId) {
    if (categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteDonViNgoai({id: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
    }
  }
  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  checkValidate(){
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  toggleDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
    this.props.validators['danhMuc'] = [];
  }

  openAddNewCategory() {
    this.setState({isSubmit: false});
    this.toggleDialog();
    this.setState({
      ten: '',
      donViNgoaiHeThongId: ''
    });
  }

  openUpdateCategory(item) {
    this.setState({isSubmit: false});
    this.toggleDialog();
    this.setState({
      donViNgoaiHeThongId: item.donViNgoaiHeThongId,
      ten: item.ten
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Đơn vị ngoài hệ thống</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('DONVINGOAIHETHONG_THEM') ?
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
                : null
              }
            </div>
          </div>
          <div className="bottom-content">
            <Search parents={this}/>
            <DataTable
              header = {header.categoryGroup.donViNgoai}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport
              parent= {this}
              search = {this.state.search}
              tableLoading = {this.state.tableLoading}
            >
              <RowItemDonViNgoai/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.toggleDialog.bind(this)}
            title={this.state.donViNgoaiHeThongId != '' ? 'Chỉnh sửa đơn vị' : 'Thêm mới đơn vị'}
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <Input className="" label="Tên" value={this.state.ten} require={true} maxLength={40} onChange={this.onChange.bind(this, 'ten')}
                bindValidator={this} channel="danhMuc"/>
            </div>
            <div className="pt-dialog-footer">
              <Link onClick={this.toggleDialog.bind(this)} className="btn-action btn-close" >
                <span>Đóng</span>
              </Link>
              <Link className={this.state.buttonLoading ? "btn-action btn-save btn-loading" : "btn-action btn-save"} onClick={this.createCategory.bind(this)}>
                <span>{this.state.donViNgoaiHeThongId != '' ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

DonViNgoai.defaultProps = {
  validators: {}
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(DonViNgoai);



// WEBPACK FOOTER //
// ./src/components/modules/category/DonViNgoai.jsx